import { FC, PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundImage: 'linear-gradient(to right bottom, rgb(254, 247, 246), rgb(249, 249, 250))',
      }}
      paddingX={4}
      py={6}
    >
      <Grid container maxWidth="md" mx="auto">
        <Grid size={12}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
};
